import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipList } from '@angular/material/chips';
import { CampaignsService } from 'src/app/pages/campaign-module/campaigns/campaigns.service';
import { debounceTime, filter, distinctUntilChanged, map, takeUntil, } from 'rxjs/operators';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription, fromEvent } from 'rxjs';
import * as moment from "moment";
import * as _ from 'lodash';

@Component({
  selector: 'esc-group-selector',
  templateUrl: './group-selector.component.html',
  styleUrls: ['./group-selector.component.scss']
})
export class GroupSelectorComponent implements OnInit {
  @Input() textLabel;
  @Input() wrapperLayoutAlign;
  @Input() labelFlex;
  @Input() formWrapperFlex;
  @Input() selectedCampaign;
  @Input() selectedGroup;
  @Input() selectedWebUser;
  @Input() allocationLevel;
  @Input() isWebUserMultiSelect;
  @Output() groupSelected = new EventEmitter;
  @ViewChild('chipsGroup') chipsBranch: MatChipList;
  
  @ViewChild('groupAC') groupACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) groupACTr: MatAutocompleteTrigger;

  formGroup: FormGroup;
  originals = [];
  loading = {
    group: false,
    init: false,
    more: false,
    error: false
  };
  public groups = [];
  private currentFilters;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  multiSelect = {
    selectedGroups: [],
  }
  public defaultOption = {
    id: 0,
    code: "all",
    description: "All",
    selected: false
  };

  constructor(
    private fb: FormBuilder,
    private helper: HelperService,
    public campSvc: CampaignsService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.detectFormChanges();
  }

  ngOnDestroy() {}

  initForm() {
    this.formGroup = this.fb.group({
      group: [null, [Validators.required, this.helper.checkIfObject]]
    })

    if(this.selectedGroup) {
      this.formGroup.get('group').setValue(this.selectedGroup.map(e => { return e.id }));
      this.multiSelect.selectedGroups = this.selectedGroup;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes.selectedGroup && !changes.selectedGroup.firstChange) {
      this.formGroup.get('group').setValue(changes.selectedGroup.currentValue, { emitEvent : false });
      if(!changes.selectedGroup.currentValue) {
        this.multiSelect.selectedGroups = [];
      }
    }

    if(changes && changes.selectedWebUser && !changes.selectedWebUser.firstChange) {
      this.currentFilters.web_filter.user_ids = this.getSelectedWebUsers();
    }
  }

  detectFormChanges() {
    this.formGroup.get('group').valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.currentFilters.web_filter.keyword = _.toString(value);
      this.groups = [];
      this.getListData();
    });
  }

  getInitialValues(data) {
    this.currentFilters.web_filter.offset = 0;
    this.currentFilters.web_filter.keyword = "";
    this.groups = [];
    this.getListData();
  }

  getMoreData(name) {
    if (this.currentFilters.getMore) {
      this.currentFilters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getListData();
    }
  }

  getSelectedWebUsers() {
    if (this.isWebUserMultiSelect) {
      const userIds = _.map(_.filter(this.selectedWebUser, { selected: true }), 'user_id');
      return userIds.length ? userIds : [0];
    } else {
      return [_.get(this.selectedWebUser, 'user_id') || 0];
    } 
  }

  getListData() {
    const distribution_id = this.selectedCampaign ? this.selectedCampaign.distribution_id : 0;
    this.currentFilters.web_filter.user_ids = this.getSelectedWebUsers();
    this.currentFilters.web_filter.distribution_id = distribution_id;

    this.loading.group = true;
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.groups.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    if(!this.helper.isUserAdmin()) {
      this.currentFilters.web_filter.user_ids = [localStorage.getItem("userId")];
    }

    // If user has role of root, get groups of selected web users in dropdown
    if(this.helper.isUserRoot()) {
      this.currentFilters.web_filter.user_ids = this.getSelectedWebUsers();
    }

    this.campSvc.getUserGroups(_.get(this, 'allocationLevel'), this.currentFilters)
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.group = false;
        this.loading.init = false;
        this.loading.more = false;
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.loading.error = true;
          this.groups = [];
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.groups[0] = this.defaultOption;
          this.groups = this.groups.concat(res.data);

          this.checkSelected('groups', 'selectedGroups', 'group');

          if((res.data.length > 0) && (this.groups.length < _.get(res, 'count'))) {
            this.currentFilters.getMore = true;
          }
        } else {
          this.groups = [];
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.loading.group = false;
        if (this.groups.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.limit -= this.currentFilters.web_filter.offset;
        }
        return observableOf(null);
      });
  }

  displayFn(data?: any): string | undefined {
    if(data) {
      return _.get(data, 'code') + ' - ' + _.get(data, 'description');
    }
    return null;
  }

  autoCmpltClosed() {
    if (_.has(this.formGroup.get('group'), 'value') && _.isArray(_.get(this.formGroup.get('group'), 'value'))) {
      this.groupSelected.next(_.get(this.formGroup.get('group'), 'value'))
    }
  }

  clearForm(ev: Event) {
    this.groups = [];
    this.multiSelect.selectedGroups = [];
    this.formGroup.get('group').setValue(null, {emitEvent: false});
    this.groupSelected.next(null);
    ev.stopPropagation();
  }

  checkSelected(srcArray, targetArray, formControlName) {
    if(this.multiSelect[targetArray].some(opt => opt.description == 'All')) {
      let tempObj = _.cloneDeep(this.defaultOption);
      tempObj.selected = false;
      this.toggleSelection(tempObj, this[srcArray], targetArray, formControlName, null);
    } 
    else if (this.multiSelect[targetArray].length) {
      this[srcArray].forEach(e => {
        this.multiSelect[targetArray].forEach(v => {
          if(e.description == v.description) {
            e.selected = v.selected;
          }
        })
        if(e.description == 'All') {
          e.selected = false;
        }
      })
    } else {
      this[srcArray].forEach(e => {
        e.selected = false;
      })
    }
  }

  optionClicked(event: Event, data, srcArray, targetArray, formControlName, inputElem) {
    event.stopPropagation();
    this.toggleSelection(data, srcArray, targetArray, formControlName, inputElem);
  }
 
  toggleSelection(data, srcArray, targetArray, formControlName, inputElem) {
    if(inputElem) {
      inputElem.value = '';
    }

    // console.log(data, srcArray, targetArray, formControlName, inputElem)
    data.selected = !data.selected;
 
    //if 'all' is selected, choose only all
    if(data.selected == true && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = true;
      });
      this.multiSelect[targetArray] = [];
      this.multiSelect[targetArray].push(data);
      this.disableCheckbox(srcArray, formControlName, data);
    } 
 
    //if 'all' is deselected, unselect everything
    else if(data.selected == false && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = false;
      });
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      this.enableCheckbox(srcArray);
    } 
 
    else if(this.multiSelect[targetArray].indexOf(data) == -1) {
      //if other option is selected, check if 'all' is already selected and clear selection
      // this.multiSelect[targetArray].some(opt => opt.code == data.code)
      if(this.multiSelect[targetArray].indexOf(this.defaultOption) > -1) {
        srcArray.forEach(e => {
          e.selected = false;
        });
        this.multiSelect[targetArray] = [];
      } 
      //if data exists in array, remove from list
      else if(this.multiSelect[targetArray].some(opt => opt.code == data.code)) {
        let index = _.findIndex(this.multiSelect[targetArray], function(item) { return item['code'] == data.code })
        this.multiSelect[targetArray].splice(index, 1);
      } 
      else {
        this.multiSelect[targetArray].push(data);
      }
    } 
    
    else {
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      srcArray.forEach(e => {
        if(e.id == data.id) {
          e.selected = false;
        }
      });
    }
  
    this.assignFormValues(targetArray, formControlName);

    // Added this to trigger event output when mat-chip is removed by button
    this.autoCmpltClosed();
  }
 
  enableCheckbox(optionArray) {
    optionArray.forEach(e => {
      e.disabled = false;
    })
  }
 
  disableCheckbox(optionArray, formControlName, data) {
    if (optionArray[0].selected && (_.has(this.formGroup.get(formControlName), 'value') && this.formGroup.get(formControlName).value == 0) || (_.get(data, 'code') == 'all')) {
      optionArray.forEach(e => {
        if(e.code != 'all') {
          e.disabled = true;
        }
      })
    } else {
      this.enableCheckbox(optionArray);
    }
  }
 
  assignFormValues(targetArray, formControlName) {
    let tempArr;
    tempArr = this.multiSelect[targetArray].map(e => {
      return e;
    });
    this.formGroup.get(formControlName).setValue(tempArr);
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }
  checkAutocompleteObject(control, objectKey, targetArray) {
    if ((!_.isObject(control.controls[objectKey].value) || control.controls[objectKey].value.id == null) && control.controls[objectKey].value != "") {
      control.controls[objectKey].setErrors({
        "notExisting": true
      });
    }

    if(_.size(this.multiSelect[targetArray]) && targetArray) {
      // control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    limit: 50,
		offset: 0,
		keyword: "",
		is_asc: 1,
    user_ids: [0],
    group_filter_ids: [0]
  }
}